import { useMemo } from "react";
import { FEATURES as AppFeatures, FEATURE_ACTION } from "constants/features";
import { usePermissionsState } from "context";
import { FEATURES as OvouFeatures, useHasPermission } from "@ovou-inc/ovou-ui";

// Accepts admin-app keys (local enum) and shared permission keys (ovou-ui — the
// canonical source). Both resolve to a `${action}_${feature}` string lookup.
const useCheckPermission = (
  action: FEATURE_ACTION,
  feature: AppFeatures | OvouFeatures,
): boolean => {
  const { permission } = usePermissionsState();
  const { default_permission: permissionSet } = permission || {};
  return useMemo(() => {
    return useHasPermission(
      permissionSet || null,
      feature as any,
      action,
    ) as boolean;
  }, [permissionSet, feature, action]);
};

export default useCheckPermission;
